import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'
import { AdminContext } from 'contexts/AdminContext'

import { Portlet, Col, Row, Button, Form } from '_zari/core'

import * as FormGroups from './formGroups'
import * as Modals from './modals'

import * as BackgroundJobsService from 'services/backgroundJobs.service'

const portletBreadcrumbs = [{ name: 'Mayorizacion' }]

const PASOS_MAYORIZACION = [
  { codigo: 'VALIDACIONES', nombre: 'Validar' },
  { codigo: 'DIFERENCIA_TCAMBIO', nombre: 'Diferencia T/C' },
  { codigo: 'DEPRECIACION', nombre: 'Depreciacion' },
  { codigo: 'FINAL', nombre: 'Finalizar' }
]

const MainForm = () => {
  const __zariContext = React.useContext(ZariContext)
  const __adminContext = React.useContext(AdminContext)

  const [mostrarDetallesDiferenciaTCModal, setMostrarDetallesDiferenciaTCModal] = React.useState(false)

  const formInitialValues = React.useMemo(() => {
    return {
      desdeMes: __adminContext.mesTrabajo,
      hastaMes: __adminContext.mesTrabajo
    }
  }, [__adminContext.mesTrabajo])

  const enviarMayorizacion = (formData, setSubmitting, paso = 'TODO') => {
    BackgroundJobsService.iniciarMayorizacion({ ...formData, paso })
      .then(() => {
        __zariContext.snack('info', 'Proceso de mayorizacion enviado a background.')
      })
      .catch(({ data }) => __zariContext.snack('error', data?.error || 'No se pudo iniciar el proceso.'))
      .finally(() => {
        setSubmitting(false)
      })
  }

  const onSubmit = (formData, { setSubmitting }) => {
    enviarMayorizacion(formData, setSubmitting)
  }

  return (
    <>
      {__adminContext.mesTrabajo && (
        <Portlet>
          <Portlet.Header title='Mayorizacion' breadcrumbs={portletBreadcrumbs} />
          <Portlet.Body>
            <Formik initialValues={formInitialValues} onSubmit={onSubmit}>
              {({ isSubmitting, touched, errors, handleSubmit, values, setSubmitting }) => (
                <>
                  <Form>
                    <FormGroups.MesContabilidadFormGroup
                      fIsSubmitting={isSubmitting}
                      iError={errors.desdeMes}
                      iTouched={touched.desdeMes}
                      idFormato='mayorizacion'
                      label='DESDE'
                      name='desdeMes'
                    />
                    <FormGroups.MesContabilidadFormGroup
                      fIsSubmitting={isSubmitting}
                      iError={errors.hastaMes}
                      iTouched={touched.hastaMes}
                      idFormato='mayorizacion'
                      label='HASTA'
                      name='hastaMes'
                    />
                  </Form>
                  <Row>
                    <Col md={12} className='text-right'>
                      {PASOS_MAYORIZACION.map(paso => (
                        <Button
                          key={paso.codigo}
                          disabled={isSubmitting}
                          onClick={() => {
                            setSubmitting(true)
                            enviarMayorizacion(values, setSubmitting, paso.codigo)
                          }}
                        >
                          {paso.nombre}
                        </Button>
                      ))}
                      <Button disabled={isSubmitting} onClick={handleSubmit}>
                        Mayorizacion completa
                      </Button>
                      <Button onClick={() => setMostrarDetallesDiferenciaTCModal(true)}>Verificar Tipos Cambio</Button>
                    </Col>
                  </Row>
                </>
              )}
            </Formik>
          </Portlet.Body>
        </Portlet>
      )}
      {mostrarDetallesDiferenciaTCModal && (
        <Modals.DetallesTcDiferentesModal show={mostrarDetallesDiferenciaTCModal} handleClose={() => setMostrarDetallesDiferenciaTCModal(false)} />
      )}
    </>
  )
}

export default React.memo(MainForm)
